import { Info } from 'lucide-react';
import SingleFileInput from '@/components/form/SingleFileInput.tsx';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';

const IMAGE_ACCEPT = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpeg', '.jpg'],
};

const CompanyLogoForm = () => (
  <div className="flex flex-col gap-1.5">
    <div className="flex items-center gap-1">
      <InputLabel label="Logo" />
      <Tooltip>
        <TooltipTrigger asChild>
          <Info size={14} className="text-neutral-400" />
        </TooltipTrigger>
        <TooltipContent>
          Pełnowymiarowa wersja Twojego logo. Powinno mieć co najmniej 128px na
          128px. Obsługiwane formaty to JPG i PNG.
        </TooltipContent>
      </Tooltip>
    </div>
    <SingleFileInput
      fieldName="logo"
      accept={IMAGE_ACCEPT}
      hint="JPG lub PNG, co najmniej 128 × 128 px"
    />
  </div>
);

export default CompanyLogoForm;
